export default function toCamelCase(str: string): string {
    return str.replace(/[-_]([a-z])/g, (_, letter: string) => letter.toUpperCase());
}
